import React, { Component } from 'react';
import { View } from 'react-native';
import {
  ContactScreen,
  getUrls,
  openLink,
  WebView,
  VideoDisplay,
  Theme,
} from 'fitbeat.react-native-components';

import { TitleBarAndMenu } from './TitleBarAndMenu';

const singleTermsUrl = getUrls().ALL_TERMS_AND_CONDITIONS;
const isMobile = window.innerWidth <= 550;

export class WebHelp extends Component {
  state = {};

  setActiveHelpSection = () => {
    openLink(singleTermsUrl);
  };

  setActiveContactUsSection = (activeContactUsSection) => {
    if (isMobile) {
      this.props.navigation.navigate('Contact');
      return;
    }
    this.setState({
      activeContactUsSection,
      activeVideoSection: null,
    });
  };

  setActiveVideoSection = async (activeVideoSection) => {
    await this.setState({
      activeContactUsSection: null,
      activeVideoSection: null,
    });
    await this.setState({
      activeVideoSection,
      activeContactUsSection: null,
    });
  };

  render() {
    const activeTitle = (
      this.state.activeVideoSection ? this.state.activeVideoSection.title : ''
    );
    return (
      <div>
        <TitleBarAndMenu {...this.props} />
        <div className='menu-container grid-x content-top-padding full-vh'>
          <div className='cell medium-4 large-4 small-12 white'>
            <div className='drawer-container submenu-list margin-top-0'>
              <ul className='vertical menu accordion-menu' data-accordion-menu>
                <li>
                  <a onClick={() => this.props.navigation.navigate('Faq')}>FAQ</a>
                </li>
                <li>
                  <a onClick={() => this.setActiveHelpSection()}>Legal</a>
                </li>
                <li>
                  <a onClick={() => this.setActiveContactUsSection('ContactUsSection')}>Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
          <div className='cell medium-8 large-8' style={{ backgroundColor: Theme.GREY_LIGHT }}>
            {this.state.activeContactUsSection
                            && <ContactScreen {...this.props} />}

            {this.state.activeVideoSection
                            && (
                            <View style={{
                              height: '100%',
                              paddingVertical: 30,
                              paddingHorizontal: 15,
                              position: 'relative',
                              backgroundColor: 'rgba(28,28,28,0.97)',
                            }}
                            >
                              <VideoDisplay
                                videoName={this.state.activeVideoSection.videoSource}
                                closeVideo={() => {
                                  this.setState({
                                    activeVideoSection: null,
                                  });
                                }}
                                isVideoVisible={!!this.state.activeVideoSection}
                              />
                            </View>
                            )}
          </div>
        </div>
      </div>
    );
  }
}
